// Use this for backwards compatibility with Locker
class BackwardsCompatibleStorage {
  /**
   * @param {String} key
   * @param {*} value
   * @returns {BackwardsCompatibleStorage}
   */
  store(key, value) {
    localStorage.setItem(key, JSON.stringify(value));

    return this;
  }

  /**
   * @param {String} key
   * @returns {*}
   */
  retrieve(key) { // eslint-disable-line class-methods-use-this
    return JSON.parse(localStorage.getItem(key));
  }

  /**
   * @param {String} key
   * @returns {BackwardsCompatibleStorage}
   */
  destroy(key) {
    localStorage.removeItem(key);

    return this;
  }
}

// Create new Locker instance
export const storage = new BackwardsCompatibleStorage();
